import { useAuth } from '@/context/AuthContext';

/**
 * Hook to check the current user's subscription tier
 * @returns Object with isPaid (Pro or Premium), isPremium (Premium only), and account_type
 */
export const usePremium = () => {
  const { user } = useAuth();

  // Check if user has paid account type
  // Paid account types: 'premium', 'pro'
  // Fallback to localStorage if user.account_type is not available
  const accountTypeFromUser = user?.account_type;
  const accountTypeFromStorage = localStorage.getItem('account_type');
  const accountType = accountTypeFromUser || accountTypeFromStorage;

  const paidTypes = ['premium', 'pro'];
  const isPaid = accountType ? paidTypes.includes(accountType.toLowerCase()) : false;

  // Premium-only tier (for features like Drafts, Translation, LaTeX, OCR)
  const isPremium = accountType ? accountType.toLowerCase() === 'premium' : false;

  return {
    isPaid,         // Pro or Premium (for Pro-level features)
    isPremium,      // Premium only (for Premium-exclusive features)
    accountType: accountType || 'free'
  };
};
